export const SORTING_OPTIONS = {
    DESC: 'DESC',
    ASC: 'ASC',
    NONE: 'NONE',
}